import { Component, contentChildren, effect, input, output, signal } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideCheck } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';

import { StepComponent } from './step.component';

@Component({
  selector: 'app-stepper',
  imports: [HlmButtonImports, HlmIconImports],
  templateUrl: './stepper.component.html',
  providers: [provideIcons({ lucideCheck })],
})
export class StepperComponent {
  readonly active = signal(0);
  readonly steps = contentChildren(StepComponent);

  readonly orientation = input<'horizontal' | 'vertical'>('horizontal');

  selectionChange = output<number>();

  readonly currentIndex = signal(0);

  constructor() {
    effect(() =>
      this.steps().forEach((step, i) => {
        step.active.set(i === this.active());
      }),
    );
  }

  goTo(index: number) {
    this.currentIndex.set(index);
    this.selectionChange.emit(index);
  }
}
